import axios from "axios";
import { ACCOUNTS_URL } from "../../../../../constants/config";

export function getAccountingOnboardingStatus() {
  return axios.get(`${ACCOUNTS_URL}/onboarding/status`);
}

export function activateAccountingOnboarding() {
  return axios.post(`${ACCOUNTS_URL}/onboarding/activate`);
}

export function resetAccountingOnboarding() {
  return axios.post(`${ACCOUNTS_URL}/onboarding/reset`);
}

export function completeAccountingOnboarding() {
  return axios.post(`${ACCOUNTS_URL}/onboarding/complete`);
}
